function logoSlider() {
  var logoSlider = $(".js-logo-slider");
  logoSlider.slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    fade: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
        }
      }
    ],
    variableWidth: true,
    centerPadding: '60px',
    touchThreshold: 2000,
    autoplay: true,
    autoplaySpeed: 2300,
    speed: 1400,

  });
}


export default logoSlider;